/* eslint-disable */
/*
 * TODO:
 * 
 * Parallelize getCustomizationLexicons and getLexicons.
 * Error reporting.
 * Tests.
 */

/*
 * Notes:
 * 
 * The logic for getting the lexicons is a bit complex.  First, clear
 * customizationLexicons (clearCustomizationLexicons). Then get which
 * lexicons are associated with the current customization
 * (getCustomizationLexicons/customizationLexiconsReceived), setting
 * name to 'Unknown' (since the customizationlexicon endpoint returns
 * just lexicon_uuids) and included to true. Then get the list of all
 * lexicons (getLexicons/lexiconsReceived), setting the names.  I've
 * attempted to write this such that the last two queries can be done
 * in parallel, but they're currently sequential.
 */

/*
 * This is an example of what the state looks like.
 */

/*
const exampleState = {
  // Index is customization_uuid. name is the name of the customization.

  customizations: {
    'c0136f7f-4273-46a9-a082-80da4f8f9dfd': {
      name: 'test1',
      basemodel: 'en-US_NarrowbandModel',
      status: 'unbuilt'
    },
    '174bc576-8ed7-4211-b391-b2f163771ee2': {
      name: 'test2',
      basemodel: 'janin-customizetest_03b94c60',
      status: 'building'
    }
  },

   // customization_uuid of the current customization.
  
  currentCustomization: 'c0136f7f-4273-46a9-a082-80da4f8f9dfd',

   // One entry for every lexicon the user owns, with included: true if
   // it's associated with the currentCustomization and included: false
   // otherwise. The index is lexicon_uuid. The name is the name of 
   // the lexicon.
  
  customizationLexicons: {
    'fbf92ba4-3636-4823-8701-b779c6a09d00': {
      name: 'Company Names',
      included: false
    },
    '60ccc7c2-e8e5-476a-8b88-2a4747b4800f': {
      name: 'Person Names',
      included: false
    },
    'a513acd7-692e-46d8-8358-93f895f8fb1b': {
      name: 'Twitch',
      included: false
    },
    '715817e7-d04b-4a60-b3f3-83f0897f333d': {
      name: 'Trevor Demos',
      included: false
    }
  }
}
*/

const initialState = {
  customizations: {},
  currentCustomization: '',
  customizationLexicons: {}
}

export default (state = initialState, action) => {
  let newcls
  let newcl
  let customizations
  let customization
  let lex
  
  switch (action.type) {
    case 'ADD_CUSTOMIZATION':
      customizations = {...state.customizations}
      customizations[action.customization_uuid] = { name: action.name, basemodel: action.basemodel, status: action.status }
      return {...state, currentCustomization: action.customization_uuid, customizations: customizations, customizationLexicons: {} }
    case 'UPDATE_BASE_MODEL':
      customizations = {...state.customizations}
      customization = {...customizations[action.customization_uuid]}
      customization.basemodel = action.basemodel
      customizations[action.customization_uuid] = customization
      return {...state, customizations: customizations}
    case 'UPDATE_CUSTOMIZATION_LEXICON':
      newcls = {...state.customizationLexicons}
      newcl = {...newcls[action.lexicon_uuid]}
      newcl.included = action.value
      newcls[action.lexicon_uuid] = newcl
      return {...state, customizationLexicons: newcls}
    case 'CLEAR_CUSTOMIZATION_LEXICONS':
      return {...state, customizationLexicons: {}}
    case 'CUSTOMIZATIONS_RECEIVED':
      customizations = {}
      for (customization of action.customizations) {
	customizations[customization.customization_uuid] = {
	  name: customization.name,
	  basemodel: customization.basemodel,
	  status: customization.status,
	}
      }
      return {
	customizationLexicons: {},
	currentCustomization: (action.customizations.length > 0) ? action.customizations[0].customization_uuid:'',
	customizations: customizations
      }
    case 'CUSTOMIZATION_LEXICONS_RECEIVED':
      newcls = {...state.customizationLexicons}
      for (newcl in newcls) {
	newcls[newcl].included = false
      }
      for (newcl of action.customizationLexicons) {
	if (newcl.lexicon_uuid in newcls) {
	  newcls[newcl.lexicon_uuid].included = true
	} else {
	  newcls[newcl.lexicon_uuid] = { name: 'Unknown', included: true }
	}
      }
      return {...state,
	      currentCustomization: action.customization_uuid,
	      customizationLexicons: newcls
      }
    case 'LEXICONS_RECEIVED':
      newcls = {...state.customizationLexicons}
      for (lex of action.lexicons) {
	if (lex.lexicon_uuid in newcls) {
	  newcls[lex.lexicon_uuid].name = lex.name
	} else {
	  newcls[lex.lexicon_uuid] = { name: lex.name, included: false }
	}
      }
      return {...state, customizationLexicons: newcls}
    default:
      return state
  }
}

export const addCustomization = (name) => {
  return function(dispatch, getState) {
    const rmi = getState().rmi
    rmi.customizations.post({name: name}).then(cust => {
      dispatch(customizationReceived(cust))
    }).then(cust => {
      dispatch(getLexicons())
    }).catch(m => {
      console.log("Error in addCustomization")
      console.log(m)
    })
  }
}

export const customizationReceived = (cust) => {
  return {
    type: 'ADD_CUSTOMIZATION',
    customization_uuid: cust.customization_uuid,
    name: cust.name,
    basemodel: cust.basemodel,
    status: cust.status,
  }
}

export const deleteCustomization = (customization_uuid) => {
  return function(dispatch, getState) {
    const rmi = getState().rmi
    rmi.customizations.delete({customization_uuid: customization_uuid}).then(cust => {
      dispatch(getCustomizations())
    }).catch(m => {
      console.log("Error in deleteCustomization")
      console.log(m)
    })
  }
}

export const buildCustomization = (customization_uuid) => {
  return function(dispatch, getState) {
    const rmi = getState().rmi
    rmi.customizations.build({customization_uuid: customization_uuid}).then(m => {
      dispatch(getCustomizations())
    }).catch(m => {
      console.log("Error in buildCustomization")
      console.log(m)
    })
  }
}


export const renameCustomization = (customization_uuid, newname) => {
  return function(dispatch, getState) {
    const rmi = getState().rmi
    rmi.customizations.put({customization_uuid: customization_uuid, name: newname}).then(m => {
      dispatch(getCustomizations());
    }).catch(m => {
      console.log("Error in renameCustomization")
      console.log(m)
    })
  }
}

export const updateBasemodel = (customization_uuid, basemodel, sendToApi) => {
  return function(dispatch, getState) {
    dispatch({
      type: 'UPDATE_BASE_MODEL',
      customization_uuid: customization_uuid,
      basemodel: basemodel
    })
    if (sendToApi) {
      const rmi = getState().rmi
      rmi.customizations.put({customization_uuid: customization_uuid, basemodel: basemodel}).catch(m => {
      console.log("Error in renameCustomization")
      console.log(m)
      })
    }
  }
}

export const updateCustomizationLexicon = (customization_uuid, lexicon_uuid, value) => {
  return function(dispatch, getState) {
    const rmi = getState().rmi
    dispatch({
      type: 'UPDATE_CUSTOMIZATION_LEXICON',
      lexicon_uuid: lexicon_uuid,
      value: value
    })
    if (value) {
      rmi.customizationlexicons.post({customization_uuid: customization_uuid, lexicon_uuid: lexicon_uuid}).then().catch(m => {
	console.log("Error in customizationlexicons.post")
	console.log(m)
      })
    } else {
      rmi.customizationlexicons.delete({customization_uuid: customization_uuid, lexicon_uuid: lexicon_uuid}).then().catch(m => {
	console.log("Error in customizationlexicons.delete")
	console.log(m)
      })
    }
  }
}

export const getCustomizations = () => {
  return function(dispatch, getState) {
    const rmi = getState().rmi
    return rmi.customizations.list().then(customizations => {
      dispatch(customizationsReceived(customizations))
      dispatch(clearCustomizationLexicons())
      if (customizations.length > 0) {
	dispatch(getCustomizationLexicons(customizations[0].customization_uuid))
      }
      dispatch(getLexicons())
    }).catch(m => {
      console.log('Error in getCustomizations')
      console.log(m)
    })
  }
}

export const clearCustomizationLexicons = () => {
  return {
    type: 'CLEAR_CUSTOMIZATION_LEXICONS',
  }
}

export const customizationsReceived = (customizations) => {
  return {
    type: 'CUSTOMIZATIONS_RECEIVED',
    customizations: customizations,
  }
}

export const getCustomizationLexicons = (customization_uuid) => {
  return function(dispatch, getState) {
    const rmi = getState().rmi
    return rmi.customizationlexicons.list({customization_uuid: customization_uuid}).then(cls => {
      dispatch(customizationLexiconsReceived(customization_uuid, cls))
    }).catch(m => {
      console.log('Error in getCustomizationLexicons')
      console.log(m)
    })
  }
}

export const customizationLexiconsReceived = (customization_uuid, cls) => {
  return {
    type: 'CUSTOMIZATION_LEXICONS_RECEIVED',
    customizationLexicons: cls,
    customization_uuid: customization_uuid
  }
}

export const getLexicons = () => {
  return function(dispatch, getState) {
    const rmi = getState().rmi
    return rmi.lexicons.list().then(lexs => {
      dispatch(lexiconsReceived(lexs))
    }).catch(m => {
      console.log('Error in getLexicons')
      console.log(m)
    })
  }
}

export const lexiconsReceived = (lexs) => {
  return {
    type: 'LEXICONS_RECEIVED',
    lexicons: lexs,
  }
}
